import { render, staticRenderFns } from "./project-settings-assign-guests.vue?vue&type=template&id=b7777f62&"
import script from "./project-settings-assign-guests.vue?vue&type=script&lang=ts&"
export * from "./project-settings-assign-guests.vue?vue&type=script&lang=ts&"
import style0 from "./project-settings-assign-guests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports